var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"wrapper\"><div style=\"display: block\" class=\"container apply-container\"><div ui-view=\"\"></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/applications/verify/verify.jade
// module id = 1108
// module chunks = 0